import React, { useState } from "react";
import { toast } from "react-hot-toast";

export default function RegisterModal({ open, onClose }) {
  const [role, setRole] = useState("");
  const [form, setForm] = useState({
    countryCode: "+91",
    mobileNumber: "",
    firstName: "",
    lastName: "",
    email: "",
  });
  const apiUrl = process.env.REACT_APP_API_URL;

  if (!open) return null;

  const roleOptions = [
    { value: "customer", label: "Customer" },
    { value: "peg", label: "Technician" },
    { value: "shipper", label: "Shipper" },
    { value: "caller", label: "Caller" },
    { value: "admin", label: "Admin" },
  ];

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  function handleRoleChange(e) {
    setRole(e.target.value);
    setForm({
      countryCode: "+91",
      mobileNumber: "",
      firstName: "",
      lastName: "",
      email: "",
    });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const token = localStorage.getItem('token');
    try {
      let url = "";
      let payload = {};
      if (role === "customer") {
        url = `${apiUrl}/customer/auth/signin`;
        payload = {
          countryCode: form.countryCode,
          mobileNumber: form.mobileNumber,
        };
      } else if (role === "peg") {
        url = `${apiUrl}/PEG/auth/register`;
        payload = {
          role,
          email: form.email,
          countryCode: form.countryCode,
          mobileNumber: form.mobileNumber,
          firstName: form.firstName,
          lastName: form.lastName,
        };
      } else if (role === "caller") {
        url = `${apiUrl}/caller/auth/register`;
        payload = {
          role,
          email: form.email,
          countryCode: form.countryCode,
          mobileNumber: form.mobileNumber,
          firstName: form.firstName,
          lastName: form.lastName,
        };
      } else if (role === "shipper") {
        url = `${apiUrl}/shipper/auth/register`;
        payload = {
          firstName: form.firstName,
          lastName: form.lastName,
          email: form.email,
          countryCode: form.countryCode,
          mobileNumber: form.mobileNumber,
        };
      } else if (role === "admin") {
        url = `${apiUrl}/admin/auth/register`;
        payload = {
          role,
          email: form.email,
          countryCode: form.countryCode,
          mobileNumber: form.mobileNumber,
          firstName: form.firstName,
          lastName: form.lastName,
        };
      } else {
        throw new Error("Invalid role selected");
      }
      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(role === "admin" && token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Registration failed");
      // show toast and close modal for all roles
      toast.success(data.message || "Registration successful!");
      onClose();
    } catch (err) {
      toast.error(err.message);
    }
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 w-full max-w-md shadow-lg relative">
        <button className="absolute top-2 right-2 text-xl" onClick={onClose}>&times;</button>
        <h2 className="text-2xl font-bold mb-4">Register</h2>
        <div className="mb-4">
          <label className="block mb-1 font-semibold">Register as</label>
          <select className="w-full border rounded p-2" value={role} onChange={handleRoleChange}>
            <option value="">Select Role</option>
            {roleOptions.map(opt => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
        </div>
        {role && (
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="block mb-1">Country Code</label>
              <input
                name="countryCode"
                value={form.countryCode}
                onChange={handleChange}
                className="w-full border rounded p-2"
                required
              />
            </div>
            <div className="mb-3">
              <label className="block mb-1">Mobile Number</label>
              <input
                name="mobileNumber"
                value={form.mobileNumber}
                onChange={handleChange}
                className="w-full border rounded p-2"
                required
              />
            </div>
            <>
              <div className="mb-3">
                <label className="block mb-1">First Name</label>
                <input
                  name="firstName"
                  value={form.firstName}
                  onChange={handleChange}
                  className="w-full border rounded p-2"
                  required={role !== "customer" && role !== "shipper"}
                />
              </div>
              <div className="mb-3">
                <label className="block mb-1">Last Name</label>
                <input
                  name="lastName"
                  value={form.lastName}
                  onChange={handleChange}
                  className="w-full border rounded p-2"
                  required={role !== "customer" && role !== "shipper"}
                />
              </div>
              <div className="mb-3">
                <label className="block mb-1">Email</label>
                <input
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={handleChange}
                  className="w-full border rounded p-2"
                  required={role !== "customer" && role !== "shipper"}
                />
              </div>
            </>
            <button type="submit" className="w-full bg-indigo-500 text-white py-2 rounded font-semibold mt-2">Register</button>
          </form>
        )}
      </div>
    </div>
  );
}
